import { toPublicPath, useHead } from '#imports'
import type { Ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { getMetas } from '~/utils/seo/meta'

import translations from './useModelsComparisonHeadV2.translations'

export function useModelsComparisonHead(productsNames: Ref<string[] | null>) {
  const i18n = useI18n()

  const imageUrl = toPublicPath('/img/comparison/og-image.jpg')

  useHead({
    title: () => {
      if (!productsNames.value || productsNames.value.length < 2) return ''

      return i18n(translations.ogTitle, {
        firstProduct: productsNames.value[0],
        secondProduct: productsNames.value[1],
      })
    },
    meta: () => {
      if (!productsNames.value || productsNames.value.length < 2) return []

      return getMetas({
        title: i18n(translations.ogTitle, {
          firstProduct: productsNames.value[0],
          secondProduct: productsNames.value[1],
        }),
        description: i18n(translations.ogDescription, {
          firstProduct: productsNames.value[0],
          secondProduct: productsNames.value[1],
        }),
        'og:image': imageUrl,
        'og:article:section': i18n(translations.ogSection),
      })
    },
  })
}
